import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, withInMemoryScrolling, NoPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { CustomPreloadingStrategy } from './custom-preload-strategy';
import { SUPABASE_PROVIDER } from './providers/supabase.provider';
import { environment } from '../environments/environment';

function shouldEnableServiceWorker(): boolean {
  if (!environment.production || typeof location === 'undefined') {
    return false;
  }

  return !['localhost', '127.0.0.1', '::1'].includes(location.hostname);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    // 使用 NoPreloading 策略來完全關閉預載入訊息
    provideRouter(routes, withPreloading(NoPreloading), withInMemoryScrolling({
      scrollPositionRestoration: 'top'
    })),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(), // 添加 HttpClient 支援
    provideServiceWorker('ngsw-worker.js', {
      enabled: shouldEnableServiceWorker(),
      registrationStrategy: 'registerImmediately'
    }),
    CustomPreloadingStrategy,
    SUPABASE_PROVIDER // 添加統一的 Supabase 提供者
  ]
};
